export default "__VITE_ASSET__39e6c573__"